export const fieldGroupTranslations = {
  collapsible: {
    hide: 'fieldgroup-collapsible-hide',
    show: 'fieldgroup-collapsible-show',
  },
}
